/* eslint-disable */
/* tslint:disable */

/** identifyHublerDevice
 * method: put
 * summary: Identify hubler device
 */

import type { IdentifyHublerDeviceApiBadRequestResponse } from './../api-types'

export const path = `/bff-worker/device`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/device`

export type IdentifyHublerDeviceSuccess = never
export type IdentifyHublerDeviceError =
  IdentifyHublerDeviceApiBadRequestResponse
